import styled from "styled-components";
import { Cell } from "../../ui";

export default styled(Cell)`
    font-family: "VT323", monospace;
    font-weight: 400;
    font-style: normal;
    font-size: 3.2rem;
    line-height: 1.8rem;;
    vertical-align: middle;

    & img {
        image-rendering: pixelated;
        image-rendering: -moz-crisp-edges;
        image-rendering: crisp-edges;
        margin: 0 0.1em;
    }

    & span {
        font-size: 3rem;
        line-height: 1.5rem;
        display: inline-block;
        vertical-align: middle;
        margin-top: -0.5rem;
        margin-left: -0.6rem;
        margin-right: 0.75rem;
    }
`